<template>
  <div class="gk-table-container" style="position: relative" v-loading="tableLoading">
    <div class="gk-table-control">
      <div class="gk-table-search" v-if="config.form">
        <div class="gk-table-search-item">
          <gk-form
            ref="gkForm"
            :form="config.form"
            @on-fields-change="fieldsChange"
          >
            <template #btns>
              <el-button
                type="primary"
                size="small"
                icon="el-icon-search"
                @click="handleSearch"
                >查询</el-button
              >
            </template>
          </gk-form>
        </div>
      </div>
      <slot name="gk-table-tools" :value="tablePage"></slot>
    </div>
    <div class="gk-table-list" style="position: relative">
      <slot name="gk-table-btn" />
      <el-table
        v-bind="tableAttrsForEl"
        v-on="tableListeners"
        @sort-change="sortChange"
        @selection-change="handleSelectionChange"
      >
        <template v-for="(c, i) in gkSelectionColumns">
          <el-table-column
            v-if="c.slot"
            :key="columnRowKey(c, 'sel', i)"
            :label="c.title"
            :width="c.width"
            :fixed="c.fixed"
            :align="c.align"
            :show-overflow-tooltip="c.tooltip"
            :sortable="c.sortable"
          >
            <template slot-scope="scope">
              <slot :name="c.slot" v-bind="scope.row" />
            </template>
          </el-table-column>
          <el-table-column
            v-else
            v-bind="c"
            :key="columnRowKey(c, 'sel', i)"
            :prop="c.key"
            :label="c.title"
            :sortable="c.sortable"
          />
        </template>
        <el-table-column
          v-if="gkShowIndexColumn"
          label="序号"
          type="index"
          :width="indexColumnWidth"
          align="center"
        />
        <template v-for="(c, i) in gkBodyColumns">
          <el-table-column
            v-if="c.slot"
            :key="columnRowKey(c, 'body', i)"
            :label="c.title"
            :width="c.width"
            :fixed="c.fixed"
            :align="c.align"
            :show-overflow-tooltip="c.tooltip"
            :sortable="c.sortable"
          >
            <template slot-scope="scope">
              <slot :name="c.slot" v-bind="scope.row" />
            </template>
          </el-table-column>
          <el-table-column
            v-else
            v-bind="c"
            :key="columnRowKey(c, 'body', i)"
            :prop="c.key"
            :label="c.title"
            :sortable="c.sortable"
          />
        </template>
        <template #empty>
          <building flag="none" />
        </template>
      </el-table>
      <el-pagination
        v-if="config.tableNoPage"
        :total="tablePage.total"
        @current-change="handlePageChange"
        @size-change="handlePageSizeChange"
      />
    </div>
  </div>
</template>
  
  <script>
/* eslint-disable */
import building from '@views/workspace/components/building.vue'
export default {
  name: "gk-table",
  components: {
    building
  },
  props: {
    config: Object,
  },
  data() {
    return {
      tableLoading: false,
      tableAttrs: {
        columns: [],
        data: [],
        border: true,
      },
      tableSlots: [],
      tableListeners: {},
      tablePage: {
        total: 0,
        from: 1,
        size: 10,
      },
      tableFields: {
        total: "total_count",
        list: "data",
        from: "from",
        size: "size",
      },
    };
  },
  watch: {
    config: {
      handler(v) {
        const { table = {}, tableRequest } = v;
        const { attrs = {}, listeners = {}, fields = {} } = table;
        this.tableAttrs = { ...this.tableAttrs, ...attrs };
        this.tableListeners = listeners;
        this.tableFields = { ...this.tableFields, ...fields };
        this.tableSlots = (attrs.columns || []).filter((c) => c.slot);

        if (tableRequest) {
          this.$nextTick(() => {
            this.handleSearch();
          });
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    /** 传给 el-table 的属性（columns 仅用于本组件渲染，不传给 el-table） */
    tableAttrsForEl() {
      const { columns, ...rest } = this.tableAttrs
      return rest
    },
    gkSelectionColumns() {
      return (this.tableAttrs.columns || []).filter((c) => c.type === 'selection')
    },
    gkBodyColumns() {
      return (this.tableAttrs.columns || []).filter((c) => c.type !== 'selection')
    },
    /** 可通过 config.table.attrs.showIndex = false 关闭序号列 */
    gkShowIndexColumn() {
      const attrs = this.config && this.config.table && this.config.table.attrs
      const show = attrs && attrs.showIndex
      return show !== false
    },
    indexColumnWidth() {
      const attrs = this.config && this.config.table && this.config.table.attrs
      const w = attrs && attrs.indexWidth
      return w != null ? w : 50
    }
  },
  methods: {
    columnRowKey(c, prefix, index) {
      if (c && c.key != null && c.key !== '') {
        return `${prefix}-${c.key}`
      }
      return `${prefix}-${index}`
    },
    handlePageChange(v) {
      this.tablePage.from = v;
      this.handleSearch();
    },
    handlePageSizeChange(s) {
      this.tablePage.size = s;
      this.handleSearch();
    },
    async handleSearch() {
      const {
        form,
        tableRequest,
        tableParams = {},
        searchResetParams,
        handleTableResult,
      } = this.config;

      let params = {};
      // 如果配置了搜索项
      if (form) {
        params = await this.$refs.gkForm.handleSubmit();
        if (searchResetParams) {
          params = searchResetParams(params);
        }
      }
      params = {
        ...tableParams,
        ...params,
        from: this.tablePage.from,
        size: this.tablePage.size,
      };
      // 查询列表
      try {
        this.tableLoading = true
        const res = await tableRequest(params);
        const result = res && res.result || { total_count: 0, data: [] };
        if (result) {
          this.tablePage.total = result[this.tableFields.total];
          let rows = handleTableResult
            ? handleTableResult(result)
            : result.list || result[this.tableFields.list]
          if (rows == null && result.result) {
            rows = result.result[this.tableFields.list]
          }
          this.tableAttrs.data = rows || []

          this.$emit("tableData", result);
        }
      } catch (error) {
        this.$message({
          message: "查询失败，请重试",
          type: "error",
        });
      } finally {
        setTimeout(() => {
          this.tableLoading = false;
        }, 300)
      }
    },
    sortChange(col) {
      this.$emit("sortChange", col);
    },
    handleSelectionChange(col) {
      this.$emit("selectionChange", col);
    },
    async fieldsChange() {
      const { form } = this.config;
      let params = {};
      // 如果配置了搜索项
      if (form) {
        params = await this.$refs.gkForm.handleSubmit();
        this.$emit("formChange", params);
        this.tablePage.from = 1;
      }
    },
  },
};
</script>
  
  <style lang="scss">
.gk-table-container {
  padding: 16px 20px 0;
  .ivu-table-wrapper ::-webkit-scrollbar {
    height: 5px !important;
  }
  .ivu-page {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
    flex-wrap: nowrap;

    .ivu-page-options {
      display: flex;
      flex-wrap: nowrap;

      .ivu-page-options-elevator {
        white-space: nowrap;
        display: flex;
        flex-wrap: nowrap;
      }
    }
  }

  .ivu-table {
    font-size: 14px;
    font-weight: 400;
    color: #1d2129;
  }

  .ivu-table:before,
  .ivu-table-border:after {
    background-color: #f0f0f0;
  }

  .ivu-table-wrapper-with-border {
    border-color: #f0f0f0;
    overflow: hidden;
  }

  .ivu-table th {
    background: #f0f0f0;
    font-weight: bold;
    color: #89919f;
    border-color: #f0f0f0;
  }

  .ivu-table td,
  .ivu-table th {
    border-color: #f0f0f0;
  }
}
</style>
  